import { render, staticRenderFns } from "./brand-list.vue?vue&type=template&id=26aaeda4&scoped=true"
import script from "./brand-list.vue?vue&type=script&lang=js"
export * from "./brand-list.vue?vue&type=script&lang=js"
import style0 from "./brand-list.vue?vue&type=style&index=0&id=26aaeda4&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26aaeda4",
  null
  
)

export default component.exports